const urlName = '/exam/v1'
export default API => ({
    // 练习列表
    findUserExams({ data, params }) {
        return API({ 
            url: `${urlName}/userPracticeX/findUserExams`,
            params,
            data
        });
    },
    // 练习详情
    modelInfo({ data, params }) {
        return API({ 
            url: `${urlName}/userPractice/modelInfo`,
            params,
            data
        });
    },
})